<template>
  <transition
      name="b-layer-fade"
      @after-enter="afterEnter"
      @after-leave="afterLeave">
    <div class="b-layer" @click.self="closeLayerByMask(maskClose)" v-show="visible">
      <div class="b-layer-box" :class="layerClass" :style="layerStyle">
        <div class="b-layer-top">
          <div class="b-layer-name">
            {{ name }}
          </div>
          <div class="b-layer-btn-close" @click="closeLayer"></div>
        </div>
        <div class="b-layer-box-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import Lib from '../../../wrenches/Lib'

export default {
  name: 'BLayer',
  data() {
    return {
      isVisible: false,
    }
  },
  props: {
    name: {
      type: String,
      default: '弹出层'
    },
    visible: {
      type: Boolean,
      default: false,
    },
    maskClose: {
      type: Boolean,
      default: false,
    },
    width: [Number, String],
    // 全屏
    fullScreen: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(nv, ov) {
      if (nv) {
        this.openLayer()
      }
    },
  },
  computed: {
    layerClass() {
      const classTags = []
      if (this.fullScreen) {
        classTags.push('b-layer-full-screen')
      } else {
        classTags.push('b-layer-small-screen')
      }
      return classTags
    },
    layerStyle() {
      const style = []
      //     if (!this.fullScreen) {
      const layerWidth = () => {
        if (Lib.isNumber(this.width)) {
          return `${this.width}px`
        } else if (Lib.isString(this.width)) {
          return this.width
        }
        return '520px'
      }
      style.push({
        width: layerWidth()
      })
      //     }
      return style
    },
  },
  methods: {
    openLayer() {
      this.$emit('open')
    },
    closeLayer() {
      // console.log('关闭')
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    closeLayerByMask(isAllow) {
      if (isAllow) {
        this.closeLayer()
      }
    },
    /**
     * 动画进入
     */
    afterEnter() {
      // console.log('进入')
      this.$emit('enter')
    },
    /**
     * 动画离开
     */
    afterLeave() {
      this.$emit('leave')
    },
  },
  mounted() {
    // console.log('-------', this.visible);
  },
}
</script>
